// src/internal/hooks/use-small-screen.ts
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
function useSmallScreen() {
  const theme = useTheme();
  const sm = useMediaQuery(theme.breakpoints.down("lg"));
  return sm;
}

export {
  useSmallScreen
};
